export default __webpack_public_path__ + "static/quote3-ef8266c8f3d8f593df4b3e8a781a91a2.svg";